// Product page
window.dataLayer = window.dataLayer || [];


const dataLayerSingleProductSubscriptionChange = (isCart = false) => {
  let intervalsSelectors;
  let fakerSelectors;

  // Generate selectors for cart page
  if (isCart) {
    const cartItems = Array.from(document.querySelectorAll('tr[data-item]'));
    intervalsSelectors = cartItems.map((item) => `input[name="cart[${item.dataset.item}][convert_to_sub]"]`).join(',');
    fakerSelectors = cartItems.map((item) => `.subscription-option input[name="cart[${item.dataset.item}][convert_to_sub]"]`).join(',');

    // Generate selectors for single product page
  } else {
    const { postId } = document.body.dataset;
    intervalsSelectors = `input[name="convert_to_sub_${postId}"]`;
    fakerSelectors = `.subscription-option input[name="convert_to_sub_${postId}"]`;
  }

  const product = document.querySelector('.product_title');

  if (!product) {
    return;
  }

  const productName = product.innerText;
  const intervals = Array.from(document.querySelectorAll(intervalsSelectors));
  intervals.forEach((option) => {
    option.addEventListener('change', () => {
      window.dataLayer.push({
        event: 'subscription_product_switch',
        product_name: productName,
        frequency: option.value,
      });
    });
  });

  // Fix support for faker - used on single products where you can choose between one time delivery or subscription
  const faker = document.querySelector('.subscription-option-faker .subscription-option-faker-checkbox');
  if (faker) {
    const firstOption = document.querySelector(fakerSelectors);
    faker.addEventListener('change', () => {
      if (faker.checked) {
        window.dataLayer.push({
          event: 'subscription_product_switch',
          product_name: productName,
          frequency: firstOption.value,
        });
      }
    });
  }
};


if (document.body.classList.contains('single-product') || document.body.classList.contains('woocommerce-cart')) {
  // Is a single product with subscription (not bundle)
  if (document.querySelector('.subscription-option')) {
    dataLayerSingleProductSubscriptionChange(document.body.classList.contains('woocommerce-cart'));
  }
}
